<template>
    <svg width="42" height="28" viewBox="0 0 42 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_3_1753)">
            <path d="M8.81222 25.8508L34.8122 15.7397C36.7341 14.9923 38 13.1417 38 11.0797V2L2 14V21.1908C2 24.7076 5.53454 27.1255 8.81222 25.8508Z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
        </g>
        <defs>
            <clipPath id="clip0_3_1753">
                <rect width="42" height="28" fill="white"/>
            </clipPath>
        </defs>
    </svg>
</template>

<script>
export default {
    name: 'SVGSeparatorAdd',
};
</script>

<style scoped lang="scss">

</style>
